import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Grid,
    Card,
    CardMedia,
    CircularProgress,
    Container,
} from "@mui/material";

function FinancialServices() {
    const [financial, setFinancial] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get("/files/industries/financial_services.txt")
            .then((res) => {
                setFinancial(res.data);
                setLoading(false);
            })
            .catch((err) => console.error("Error loading data:", err));
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            {/* Title */}
            <Typography
                variant="h3"
                align="center"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "#030366",
                    mt: 7,
                    fontSize: {
                        xs: "1.8rem",  // mobile (~h4)
                        sm: "2.2rem",  // tablet (~h3)
                        md: "2.8rem",  // laptop (~h3+)
                        lg: "3rem",    // desktop (~h2)
                    },
                }}
            >
                Financial Services
            </Typography>

            {loading ? (
                <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress color="secondary" />
                </Box>
            ) : (
                <Grid
                    container
                    spacing={4}
                    alignItems="flex-start"
                    sx={{
                        flexDirection: {
                            xs: "column", // mobile
                            sm: "column", // tablet
                            md: "row",   // laptop & desktop
                        },
                    }}
                >
                    {/* Content Section */}
                    <Grid
                        item
                        xs={12}
                        md={7}
                        sx={{
                            width: { xs: "100%", md: "60%" },
                            order: { xs: 1, md: 1 }, // content first always
                        }}
                    >
                        {financial &&
                            financial.map((item, index) => (
                                <Box key={index} mb={3}>
                                    {typeof item === "string" ? (
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                mb: 1,
                                                textAlign: "justify",
                                                fontSize: "18px",
                                            }}
                                        >
                                            {item}
                                        </Typography>
                                    ) : (
                                        Object.entries(item).map(([key, value]) => (
                                            <Box key={key} mb={2}>
                                                <Typography
                                                    variant="h6"
                                                    sx={{
                                                        fontWeight: "600",
                                                        color: "#030366",
                                                        mb: 1,
                                                    }}
                                                >
                                                    {key}
                                                </Typography>
                                                {typeof value === "string" ? (
                                                    <Typography
                                                        variant="body1"
                                                        sx={{
                                                            textAlign: "justify",
                                                            fontSize: "17px",
                                                        }}
                                                    >
                                                        {value}
                                                    </Typography>
                                                ) : (
                                                    value &&
                                                    value.map((subitem, i) => (
                                                        <Typography
                                                            key={i}
                                                            variant="body2"
                                                            sx={{
                                                                ml: 2,
                                                                fontSize: "16px",
                                                            }}
                                                        >
                                                            • {subitem}
                                                        </Typography>
                                                    ))
                                                )}
                                            </Box>
                                        ))
                                    )}
                                </Box>
                            ))}
                    </Grid>

                    {/* Image Section */}
                    <Grid
                        item
                        xs={12}
                        md={5}
                        sx={{
                            width: { xs: "100%", md: "35%" },
                            order: { xs: 2, md: 2 }, // image below in mobile/tablet
                        }}
                    >
                        <Card
                            sx={{
                                borderRadius: 3,
                                overflow: "hidden",
                                boxShadow: 4,
                                width: "100%",
                            }}
                        >
                            <CardMedia
                                component="img"
                                image="/images/financial.jpg"
                                alt="Financial"
                                sx={{
                                    width: "100%",
                                    height: { xs: 250, sm: 300, md: 450 },
                                    objectFit: "cover",
                                }}
                            />
                        </Card>
                    </Grid>
                </Grid>
            )}
        </Container>
    );
}

export default FinancialServices;










// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//     Box,
//     Typography,
//     Grid,
//     Card,
//     CardContent,
//     CardMedia,
//     CircularProgress,
//     Container,
// } from "@mui/material";

// function FinancialServices() {
//     const [financial, setFinancial] = useState(null);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         axios({
//             method: "GET",
//             url: "/files/industries/financial_services.txt",
//         }).then((res) => {
//             setFinancial(res.data);
//             setLoading(false);
//         });
//     }, []);

//     return (
//         <Container maxWidth="lg" sx={{ py: 2 }}>
//             {/* Title */}
//             <Typography
//                 variant="h3"
//                 align="center"
//                 gutterBottom
//                 sx={{ fontWeight: "bold", color: "#030366", mt: 7 }}
//             >
//                 Financial Services
//             </Typography>

//             {loading ? (
//                 <Box display="flex" justifyContent="center" mt={4}>
//                     <CircularProgress color="secondary" />
//                 </Box>
//             ) : (
//                 <Grid container spacing={4} alignItems="flex-start">
//                     {/* Content Section */}
//                     <Grid item xs={12} md={7} sx={{ width: "60%" }}>
//                         {financial &&
//                             financial.map((item, index) => (
//                                 <Box key={index} mb={3}>
//                                     {typeof item === "string" ? (
//                                         <Typography variant="body1" sx={{ mb: 1 }}>
//                                             {item}
//                                         </Typography>
//                                     ) : (
//                                         Object.entries(item).map(([key, value]) => (
//                                             <Box key={key} mb={2}>
//                                                 <Typography
//                                                     variant="h6"
//                                                     sx={{ fontWeight: "600", color: "#030366", mb: 1 }}
//                                                 >
//                                                     {key}
//                                                 </Typography>
//                                                 {typeof value === "string" ? (
//                                                     <Typography variant="body1">{value}</Typography>
//                                                 ) : (
//                                                     value &&
//                                                     value.map((subitem, i) => (
//                                                         <Typography key={i} variant="body2" sx={{ ml: 2 }}>
//                                                             • {subitem}
//                                                         </Typography>
//                                                     ))
//                                                 )}
//                                             </Box>
//                                         ))
//                                     )}
//                                 </Box>
//                             ))}
//                     </Grid>

//                     {/* Image Section */}
//                     <Grid item xs={12} md={5} sx={{ width: "35%" }}>
//                         <Card
//                             sx={{
//                                 borderRadius: 3,
//                                 overflow: "hidden",
//                                 boxShadow: 4,
//                             }}
//                         >
//                             <CardMedia
//                                 component="img"
//                                 image="/images/financial.jpg"
//                                 alt="Financial"
//                                 sx={{ height: { xs: 250, md: 450 }, objectFit: "cover" }}
//                             />
//                         </Card>
//                     </Grid>
//                 </Grid>
//             )}
//         </Container>
//     );
// }

// export default FinancialServices;
